import ComingSoon from "../../../components/comingSoon/ComingSoon";

const MySmartLearningHelper = () => {
  return (
    <ComingSoon
      content={
        <div className="text-left font-normal text-gray-800 text-sm sm:text-base">
          <strong className="mb-2"> A smarter way to close your skills gap and work towards your selected target career</strong>

          <p className="mb-2">
            We’re building an adaptive learning sidekick that designs a study path <strong>just for you</strong> —no more guessing what to learn next.
          </p>

          <strong className="mb-2">How It Works</strong>
          <p className="mb-2">Combining insights from:</p>
          <ul className="list-disc pl-5 space-y-4">
            <li>
              <p className="font-semibold">AI Literacy Quiz results</p>
            </li>
            <li>
              <p className="font-semibold">Skills gap analysis</p>
            </li>
            <li>
              <p className="font-semibold">Interview-prep performance</p>
            </li>
            <li>
              <p className="font-semibold mb-2">Your selected target career</p>
            </li>
          </ul>
          <p className="mb-2" >…we craft a <strong>hyper-personalized adaptive learning plan</strong>—complete with micro-lessons, quizzes, hands-on projects, mentor check-ins, and real-time progress updates. <strong>You decide the length of your study plan</strong>—choose a focused 4-week sprint, a steady 3-month roadmap, or anything in between, and the Helper will pace your learning accordingly.</p>
          <p className="font-semibold mb-2">Show Your Growth to Employers</p>
          <p>Opt in to our AI Talent Pool and make your learning plan and milestones visible to hiring managers actively searching for future-ready talent.</p>
        </div>
      }
    />
  );
};

export default MySmartLearningHelper;
